import { Dispatch, ReactElement } from 'react';
import { Checkbox, styled } from '@mui/material';
import {
  deaNumUsersAllSelected,
  IDeaNumUser,
  includes,
  variables,
  mailTo,
  formatDate,
  mapRole,
  certStatusLabel,
  formatDateUTC,
} from '../common';
import { TeamRequestAction } from '../team-request';
import { map as lmap } from 'lodash/fp';

export const UserRoles2d = ({
  deaNumUsers,
  selectedUserRoleKeys,
  enableAll,
  dispatchTeamRequest,
}: {
  deaNumUsers: IDeaNumUser[];
  selectedUserRoleKeys: string[];
  enableAll: boolean;
  dispatchTeamRequest: Dispatch<TeamRequestAction>;
}) => (
  <Articl>
    <h4>
      {enableAll && (
        <Checkbox
          color="primary"
          onClick={() =>
            dispatchTeamRequest({ type: 'ToggleUserRole', payload: 'all' })
          }
          checked={deaNumUsersAllSelected({
            deaNumUsers,
            selectedUserRoleKeys,
          })}
        />
      )}
    </h4>
    <h4>DEA Registration Number</h4>
    <h4>DEA Registration Expiration</h4>
    <h4>Role</h4>
    <h4>First Name</h4>
    <h4>Last Name</h4>
    <h4>Email</h4>
    <h4>Account Id</h4>
    <h4>Phone</h4>
    <h4>Business Mailing Address</h4>
    {/* <h4>Certificate State</h4> */}
    <h4>Identity Proofing Expiration</h4>
    <h4>Number of Renewal</h4>
    <h4>Certificate Serial Number</h4>
    <h4>Certificate Status</h4>
    <h4>Certificate Expiration</h4>
    <h4>Certificate Change Date</h4>
    {lmap<IDeaNumUser, ReactElement[]>(
      ({
        deaNumber,
        deaExpDt,
        role,
        firstName,
        lastName,
        loginEmail,
        key,
        phone,
        icamUuid,
        city,
        postalCd,
        stateCd,
        street1,
        street2,
        street3,
        // active,
        idExpirationDt,
        renewalInstNo,
        serialNumber,
        certStatus,
        certExpDt,
        updatedAt,
      }) => [
        <span>
          <Checkbox
            color="primary"
            onClick={() =>
              dispatchTeamRequest({ type: 'ToggleUserRole', payload: key })
            }
            checked={includes(selectedUserRoleKeys)(key)}
          />
        </span>,
        <span>{deaNumber}</span>,
        <span>{deaExpDt ? formatDateUTC(deaExpDt) : 'n/a'}</span>,
        <span>{mapRole(role)}</span>,
        <span>{firstName}</span>,
        <span>{lastName}</span>,
        <span>{loginEmail}</span>,
        <span>{icamUuid}</span>,
        <span>{phone}</span>,
        <span>
          {mailTo({ city, postalCd, stateCd, street1, street2, street3 })}{' '}
        </span>,
        // <span>{active === 1 ? 'Active' : 'Inactive'}</span>,
        <span>
          {idExpirationDt ? formatDateUTC(idExpirationDt) : 'n/a'}
        </span>,
        <span>{renewalInstNo}</span>,
        <span>{serialNumber}</span>,
        <span>{certStatusLabel(certStatus)}</span>,
        <span>{certExpDt ? formatDateUTC(certExpDt) : 'n/a'}</span>,
        <span>{updatedAt ? formatDateUTC(updatedAt) : 'n/a'}</span>,
      ]
    )(deaNumUsers)}
  </Articl>
);

const Articl = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '1rem',
  },

  '@media (min-width: 60em)': {
    display: 'grid',
    gridTemplateColumns: '5.5rem repeat(15, auto)',
    gap: '1px',

    backgroundColor: variables.grayLighter,
    border: variables.cardBorder,
    borderRadius: variables.cardBorderRadius,

    '&>*': {
      backgroundColor: '#fff',
      padding: '1rem',
    },

    '&>*+*': {
      marginTop: '0rem',
    },
  },
}));
